require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ecommerce-keyword-research-101.json") })
        }
      }, "path---ecommerce-keyword-research-101");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ecommerce-keyword-research-101!./.cache/json/ecommerce-keyword-research-101.json
// module id = 718
// module chunks = 231608221292675